module.exports = __webpack_public_path__ + "static/media/cdalogo_ri.d55660b3.svg";